import {
  queryDataBehaveCompare,
  queryDataOverview,
  queryHighFrequencyFunction,
  queryHighFrequencyUser,
  queryTrackIngObjectList,
  queryAllRole,
  downLoadBehaveCompareList,
  queryDataBehaveCompareList,
} from '../services/behaviorData';
import dayjs from 'dayjs';

export default {
  namespace: 'behaviorData',
  state: {
    xData: [],
    data: [],
    dataOverview: {},
    dataBehaveCompare: {},
    highFrequencyFunction: [],
    highFrequencyUser: [],
    trackIngObjectList: [],
    allRole: [],
    dataBehaveCompareList: [],
    filterType: 'DAY_RATIO',
    tooltip: {},
  },
  effects: {
    //今日行为数据概览
    *queryDataOverview({ payload, callback }, { call, put }) {
      const res = yield call(queryDataOverview, payload);
      yield put({
        type: 'save',
        payload: {
          dataOverview: res?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
    //行为数据统计对比
    *queryDataBehaveCompare({ payload, callback }, { call, put, select }) {
      const res = yield call(queryDataBehaveCompare, payload);
      const { filterType } = yield select((state) => state.behaviorData) || {};
      const { currentData, lastData, dataList } = res?.data || {};

      let xData = [];
      let data = [];

      if (filterType === 'CUSTOM_RATIO') {
        (dataList || []).forEach((item) => {
          xData.push(dayjs(item?.behaveDate).format('MM/DD'));
          const obj = {
            name: '总用户量',
            value: item?.totalUser,
            number: item?.num,
            behaveDate: dayjs(item?.behaveDate).format('MM/DD'),
          };
          data.push(obj);
        });
        yield put({
          type: 'save',
          payload: {
            dataBehaveCompare: res?.data,
            data,
            xData,
          },
        });
      } else {
        const xDataMap = {
          DAY_RATIO: ['今日', '昨日'],
          WEEK_RATIO: ['本周', '上周'],
          MONTH_RATIO: ['本月', '上月'],
          YEAR_RATIO: ['今年', '去年'],
        };
        const tipList = [
          {
            name: '行为事件数量',
            value: currentData?.num,
            number: currentData?.totalUser,
            behaveDate: currentData?.behaveDate,
          },
          {
            name: '行为事件数量',
            value: lastData?.num,
            number: lastData?.totalUser,
            behaveDate: lastData?.behaveDate,
          },
        ];
        yield put({
          type: 'save',
          payload: {
            dataBehaveCompare: res?.data,
            data: tipList,
            xData: xDataMap[filterType],
          },
        });
      }

      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
    //热门功能top
    *queryHighFrequencyFunction({ payload, callback }, { call, put }) {
      const res = yield call(queryHighFrequencyFunction, payload);
      let top5Data = res?.data || [];
      while (res?.data?.length < 5) {
        top5Data.push({}); // 添加元素0，或者你可以添加其他值
      }
      yield put({
        type: 'save',
        payload: {
          highFrequencyFunction: top5Data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
    //高频用户top
    *queryHighFrequencyUser({ payload, callback }, { call, put }) {
      const res = yield call(queryHighFrequencyUser, payload);
      let top5Data = res?.data || [];
      while (res?.data?.length < 5) {
        top5Data.push({}); // 添加元素0，或者你可以添加其他值
      }
      yield put({
        type: 'save',
        payload: {
          highFrequencyUser: top5Data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
    //查询事件类型下拉框
    *queryTrackIngObjectList({ payload, callback }, { call, put }) {
      const res = yield call(queryTrackIngObjectList, payload);
      yield put({
        type: 'save',
        payload: {
          trackIngObjectList: res?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
    //查询权限组
    *queryAllRole({ payload, callback }, { call, put }) {
      const res = yield call(queryAllRole, payload);
      yield put({
        type: 'save',
        payload: {
          allRole: res?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
    //下载行为事件统计列表
    *downLoadBehaveCompareList({ payload, callback }, { call }) {
      const res = yield call(downLoadBehaveCompareList, payload);
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
    //行为事件统计对比列表
    *queryDataBehaveCompareList({ payload, callback }, { call, put }) {
      const res = yield call(queryDataBehaveCompareList, payload);
      yield put({
        type: 'save',
        payload: {
          dataBehaveCompareList: res?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(res);
      }
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
